/**
 * 4 cards stats du pipeline TRA-EQ-131 (maquette).
 *  - Total dossiers (gris) -> sub-titre dynamique "{FEH} FEH · {RE} Releve Energie"
 *  - En collecte pieces (orange)
 *  - Pret a signer (bleu)
 *  - Termines (vert)
 *
 * P1-A : sub-titre de la card "Total" calcule depuis stats.byMandataire,
 * plus jamais hardcode. Si byMandataire absent (ancienne API) -> fallback
 * texte vide pour eviter toute valeur trompeuse.
 */

/**
 * Construit le sub-titre dynamique de la card "Total dossiers".
 * Affiche uniquement les mandataires actifs (>0), pour eviter "0 GMB" inutile.
 *
 * @param {{ FEH?: number, RE?: number, GMB?: number, AM_ENERGIE?: number } | undefined} byMandataire
 * @returns {string}
 */
function buildTotalSub(byMandataire) {
  if (!byMandataire) return '';
  const parts = [];
  if (byMandataire.FEH > 0) parts.push(`${byMandataire.FEH} FEH`);
  if (byMandataire.RE > 0) parts.push(`${byMandataire.RE} Releve Energie`);
  if (byMandataire.GMB > 0) parts.push(`${byMandataire.GMB} GMB`);
  if (byMandataire.AM_ENERGIE > 0) parts.push(`${byMandataire.AM_ENERGIE} AM ENERGIE`);
  return parts.join(' · ');
}

/**
 * @param {{
 *   stats: {
 *     total: number,
 *     collecte: number,
 *     pretSigner: number,
 *     termines: number,
 *     alertes: number,
 *     byMandataire?: { FEH: number, RE: number, GMB: number, AM_ENERGIE: number }
 *   }
 * }} props
 */
export default function StatsCards({ stats }) {
  const items = [
    {
      label: 'Total dossiers',
      value: stats.total,
      sub: buildTotalSub(stats.byMandataire),
      color: 'text-[#0f172a]',
    },
    {
      label: 'En collecte pieces',
      value: stats.collecte,
      sub: stats.alertes > 0 ? `${stats.alertes} alertes >7 jours` : 'OK',
      color: 'text-orange-500',
    },
    {
      label: 'Pret a signer',
      value: stats.pretSigner,
      sub: 'Devis+AH a generer',
      color: 'text-blue-500',
    },
    {
      label: 'Termines',
      value: stats.termines,
      sub: 'Livres + immat FNUCI',
      color: 'text-emerald-500',
    },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
      {items.map((it) => (
        <div key={it.label} className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
          <div className="text-[11px] uppercase tracking-wide text-[#64748b] font-medium">
            {it.label}
          </div>
          <div className={`text-3xl font-bold mt-1 ${it.color}`}>{it.value}</div>
          {it.sub && (
            <div className="text-xs text-[#94a3b8] mt-1">{it.sub}</div>
          )}
        </div>
      ))}
    </div>
  );
}
